import { render, staticRenderFns } from "./ManualImport.vue?vue&type=template&id=8605a332&scoped=true&lang=pug&"
import script from "./ManualImport.vue?vue&type=script&lang=js&"
export * from "./ManualImport.vue?vue&type=script&lang=js&"
import style0 from "./ManualImport.vue?vue&type=style&index=0&id=8605a332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8605a332",
  null
  
)

export default component.exports